import React from 'react';
import { ToastContainer } from 'react-toastify';
import RiskChargebacks from '../components/RiskChargebacks';

const PaymentReviewManagerApp = (props) => (
  <>
    <RiskChargebacks {...props} />
    <ToastContainer icon={false} />
  </>
);

export default PaymentReviewManagerApp;
